import "./PlanningCTA.css";

export default function PlanningCTA() {
  return (
    <section className="planning-cta" aria-labelledby="planning-cta-title">
      <div className="planning-cta-texture" aria-hidden="true" />

      <div className="planning-cta-wrap">
        <div className="planning-cta-copy">
          <p className="planning-cta-label">Planning a project?</p>
          <h2 id="planning-cta-title">
            Let&apos;s talk about your vision.
          </h2>
          <p className="planning-cta-sub">
            Schedule a free call with our design consultant to find the right
            path for your goals and scope.
          </p>
        </div>

        <div className="planning-cta-cta">
          <a className="planning-cta-button" href="/contact" onClick={(event) => { event.preventDefault(); window.dispatchEvent(new CustomEvent("dwellora:open-contact")); }}>
            <span>Talk to a Designer</span>
            {/* <span className="planning-cta-button-icon" aria-hidden="true">
              +
            </span> */}
          </a>
        </div>
      </div>
    </section>
  );
}
